export default {
    TFA_mainContainer: {
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100%', 
        gap: '80px'
    }
}